













































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { NavBar, Toast } from 'vant';
import { getBookMentalHealthDetails, getBookMentalHealthStatisticsCount } from '../../API/mentalhealthdetails';

@Component({
    name: 'mentalhealthDetails',
    components: {
        [NavBar.name]: NavBar,
    },
})

export default class App extends Vue {

    private unitInfo: any = {  // 书本详情
        'element': '',
        'videoResources': [],
    };
    private isFirst: Boolean = false;

    created() {
        console.log("created...");
    }
    
    mounted() {
        document.title = '心理健康';
        this.$nextTick(() =>{
            this.isFirst = true;
            this.getBookMentalHealthDetails();
        });
    }

    @Watch('$route')
    routechange(to: any, from: any) {
        document.title = '心理健康';
        if (from.name == 'mentalhealth' &&  to.name == 'mentalhealthDetails') {
            this.isFirst = true;
            this.getBookMentalHealthDetails();
        } else {
            console.log("from:", from);
            console.log('back::::::change router.');
        }
    }

    private onClickLeft(): void {
        this.$router.go(-1);
    }

    private handlePlay(index:any): void {
        console.log("handle play:::index=", index);
        for(var i=0; i<2; ++i){
            const ele:any = document.getElementById("video_" + i);
            if(ele){
                i == index ? ele.play() : ele.pause();
                if(index == 1){
                    this.getBookMentalHealthStatisticsCount(); //统计次数;
                }
            }
        }
    }

    private onClickStudy(item: any): void {
        console.log("study..........立即学习");
        console.log("item::", item);
        if (item) {
            if (item.fileType == 'pdf') {
                this.$router.push({ path: '/showpdf', query: {fileUrl: encodeURIComponent(item.filePath), fileType: item.fileType, fileName: item.fileName}});
            } else {
                var u = navigator.userAgent;
                if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
                    window.location.href = item.filePath;
                } else {
                    window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(item.filePath));
                }
            }
        }
    }

    private onClickDownload(item: any): void {
        console.log("down load..........下载资源");
        if (item && item.zipUrl) {
            this.$router.push({ path: '/download', query: { 'zipUrl': item.zipUrl } });
        } else {
            Toast('视频资源正在准备中');
        }
    }

    private getBookMentalHealthDetails(): void {
        document.title = '心理健康';
        this.unitInfo = {  // 书本详情
            'element': '',
            'videoResources': [],
        };
        const params = {
            id: this.$route.query.unitId ? this.$route.query.unitId : '-S7ozPZaT_aDAHNubAibGQ'
        }
        getBookMentalHealthDetails(params).then((res: any) => {
            console.log("get book mental health details::::::::::res:", res);
            if (res && res.success && res.obj) {
                var obj = res.obj;
                this.unitInfo.element = obj.element;
                this.unitInfo.videoResources = [{
                        tabName: '导读介绍', 
                        isVido: true, 
                        explain: '', 
                        videoUrl: obj.videoShort, 
                        videoImage: obj.bookImage ? obj.bookImage : '',
                    },{
                        tabName: '课堂实录', 
                        isVido: true,  
                        explain: obj.videoExplain,
                        videoUrl: obj.videoCourse, 
                        videoImage: obj.bookCourseImage ? obj.bookCourseImage : '',
                        videoLength: this.getVideoTime(obj.videoLength), 
                        videoStatistics: this.getVideoStatistics(obj.statistics),
                    },{
                        tabName: '教学课件', 
                        isVido: false, 
                        videoUrl: 'nomal', 
                        fileName: obj.studyName, 
                        fileType: obj.studyFileType, 
                        filePath: obj.study, 
                        zipUrl: obj.study, 
                        zipSize: obj.studySize,
                    },{
                        tabName: '教学设计', 
                        isVido: false, 
                        videoUrl: 'nomal', 
                        fileName: obj.designName, 
                        fileType: obj.designFileType, 
                        filePath: obj.design, 
                        zipUrl: obj.design, 
                        zipSize: obj.designSize,
                    },
                ];
            } else {
                if (res.msg) {
                    Toast(res.msg);
                } else {
                    Toast('章节不存在');
                }
            }
        }).catch(() => {
            Toast('网络开了小差~');
        })
    }

    private getVideoTime(videoLength: any): any {
        //Math.floor(obj.videoLength/60)
        var videoTime = '';
        if (!videoLength){videoLength = 0;}
        if (videoLength < 60) {
            videoTime = '' + videoLength + '秒';
        } else if(videoLength < 3600) {
            videoTime = '' + Math.floor(videoLength/60) + '分' + videoLength%60 + '秒';
        } else {
            videoTime = '' + Math.floor(videoLength/3600) + '时' + Math.floor((videoLength%3600)/60) + '分' + (videoLength%3600)%60 + '秒';
        }
        return videoTime;
    }

    private getVideoStatistics(statistics:any): any{
        var statisticsStr = '';
        statisticsStr = statistics ? (''+statistics) : "0";
        return statisticsStr;
    }

    private createPreImg(event: any): void {
        console.log("create pre img:::::::::::::::::::::::::::::");
        /*
        const videoEle = event.target; // 以后video dom节点
        videoEle.currentTime = 1; // 设置视频开始播放工夫（因为有些手机第一帧显示黑屏，所以这里选取视频的第一秒作为封面）
        videoEle.addEventListener('canplay', function () { // 监听video的canplay事件
            // 创立canvas元素 并设置canvas大小等于video节点的大小
            const canvas = document.createElement('canvas');
            const scale = 0.8; // 压缩系数
            canvas.width = videoEle.videoWidth * scale;
            canvas.height = videoEle.videoHeight * scale;
            // canvas画图
            canvas.getContext('2d').drawImage(videoEle, 0, 0, canvas.width, canvas.height);
            // 把canvas转成base64编码格局
            try {
                const imgSrc = canvas.toDataURL('image/png');
                // 创立img元素 插入到文档中
                const img = document.createElement('img');
                img.src = imgSrc;
                img.style.position = 'absolute';
                img.style.left = '0';
                img.style.top = '0';
                img.style.objectFit = 'cover';
                videoEle.parentNode && videoEle.parentNode.appendChild(img);
            } catch (error) {
                console.log(error);   
            }
            //document.removeChild(canvas);
        });
        */
    }

    private getBookMentalHealthStatisticsCount(): void {
        if(this.isFirst == false){
            return;
        }
        this.isFirst = false; //只记录一次;
        
        const params = {
            id: this.$route.query.unitId ? this.$route.query.unitId : '-S7ozPZaT_aDAHNubAibGQ'
        }
        getBookMentalHealthStatisticsCount(params).then((res: any) => {
            console.log("get book mental health statistics count::::::::::res:", res);
            if (res && res.success) {
            } else {
                if (res.msg) {
                    Toast(res.msg);
                }
            }
        }).catch(() => {
            //Toast('网络开了小差~');
        })
    }
}

